import React from 'react';
import {connect} from 'react-redux';
import {loadLocations} from '../../actions/locationActions';
import { Button, Input} from 'reactstrap';
import EditClientView from '../Clients/EditClientView';
import {loadBdms} from '../../actions/bdmActions';
import {loadClientsBySearch} from '../../actions/clientActions';
import CheckBoxControl from '../Common/CheckBoxControl';
import {allowUserWithRoles, BASE_URL,  IsInRole, ROLE_Admin, ROLE_OfficeUser, ROLE_SuperUser} from '../../constants';
import { push, go } from '../../utils/navigation';
import querySearch from "stringquery";
import { Outlet, useLocation } from 'react-router-dom';
import { withRouter } from '../../utils/withRouter';

class LocationsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      search: {
        searchName: '',
        isActive: true,
      },
    };

    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.searchLocations = this.searchLocations.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.handleSearchFieldChange = this.handleSearchFieldChange.bind(this);
    this.handleIsActiveChange = this.handleIsActiveChange.bind(this);
    this.handleNewLocation = this.handleNewLocation.bind(this);
    this.handleClientChange = this.handleClientChange.bind(this);
    this.handleNewClient = this.handleNewClient.bind(this);
    this.selectLocationFromClient = this.selectLocationFromClient.bind(this);
  }

  handleSearchFieldChange(e) {
    let x = {...this.state.search};

    x[`${e.target.name}`] = e.target.value;

    this.setState({search: x});
  }

  handleIsActiveChange(e) {
    this.setState({search: {...this.state.search, isActive: e.target.checked}});
  }

  handleLocationChange(ev, val) {
    if(ev){
      ev.preventDefault();
    }
    this.props.dispatch(push(`${BASE_URL}/manage/locations/${val.id}`));
  }

  handleClientChange(ev, id) {
    if(ev){
      ev.preventDefault();
    }
    this.props.dispatch(push(`${BASE_URL}/manage/clients/${id}`));
  }

  handleNewLocation(){
    this.props.dispatch(push(`${BASE_URL}/manage/locations/-1?clientId=${this.props.clientId}`));
  }

  handleNewClient() {
    this.props.dispatch(push(`${BASE_URL}/manage/clients/-1`));
  }

  searchLocations(searchName, clear){
    // Ticking "Is Active" means "yes, exclude inactive records" - maps directly, not negated.
    const excludeInactive = this.state.search.isActive;
    this.props.dispatch(loadLocations(searchName, clear, excludeInactive));
    this.props.dispatch(loadClientsBySearch(searchName, clear, excludeInactive));
  }

  resetSearch(){
    this.setState({search: {
      searchName: '',
      isActive: true,
    }});
    this.searchLocations('', true);
  }

  selectLocationFromClient(location){
    this.handleLocationChange(null, {id: location.id});
  }

  componentDidMount(){
    // Only reset search if there are no existing results
    if (!this.props.locations.loaded && this.props.locations.items.length === 0) {
      this.resetSearch();
    }
    this.props.dispatch(loadBdms());
  }

  render() {
    const {account, location} = this.props;
    // Check if we're on a child route (e.g., /manage/locations/:id or /manage/clients/:id)
    let hasSelection = location && (location.pathname.match(/\/manage\/locations\/\d+/) || location.pathname.match(/\/manage\/clients\/\d+/) || location.pathname.match(/\/manage\/locations\/-1/));
    let hasFullAccess = allowUserWithRoles(account, [ROLE_Admin, ROLE_SuperUser, ROLE_OfficeUser]);

    return (<div>
      <div className="row">
        <div className="col-md-12">
          <h4>Manage Client Locations</h4>
        </div>
      </div>

      <div className="row">&nbsp;</div>

      {!hasSelection && hasFullAccess && <div className="row">
        <div className="col-12">
          <form className="form-horizontal" onSubmit={(e) => {
            e.preventDefault();
            this.searchLocations(this.state.search.searchName, false);
          }}>
            <div className="form-group row">
              <label className="col-md-3 form-control-label" htmlFor="name">Search (Phone, Suburb, Name) :</label>
              <div className="col-md-8">

                <Input type="text"
                       value={this.state.search.searchName}
                       name="searchName"
                       onChange={this.handleSearchFieldChange}
                       placeholder="(Phone, Suburb, Name)"
                />

              </div>
            </div>
            <CheckBoxControl
              name="isActive"
              value={this.state.search.isActive}
              onChange={this.handleIsActiveChange}
              labelText="Is Active"
            />
            <div className="form-group row">
              <div className="col-12">
                <button type="Submit" className="btn btn-primary"><i className='fa fa-search'/>&nbsp;Search</button>
                &nbsp;
                <Button color='seconday' onClick={this.resetSearch}>Clear</Button>&nbsp;
                <Button color="success" onClick={this.handleNewClient}><i className='fa fa-plus'/>&nbsp;New
                  Client</Button>
              </div>
            </div>
          </form>
        </div>
      </div>}

      {!hasSelection && hasFullAccess && <div className="row">
        <table className="table table-responsive table-striped" style={{minWidth: '300px'}}>
          <thead>
          <tr>
            <th style={{width: '50%'}}>Location Name</th>
            <th style={{width: '50%'}}>Client Company Name</th>
            <th>Tin Location</th>
          </tr>
          </thead>
          <tbody>
          {this.props.locations.items.length === 0 && !this.props.locations.loaded && <tr>
            <td>Searching...</td>
            <td>&nbsp;</td>
          </tr>}
          {this.props.locations.items.length === 0 && this.props.locations.loaded && <tr>
            <td>Please search for a location</td>
            <td>&nbsp;</td>
          </tr>}
          {this.props.locations.items.map(x => {
            return (<tr key={x.id}>
              <td style={{width: '50%'}}><a href="#"
                                            onClick={(e) => this.handleLocationChange(e, x)}>{x.locationName}</a></td>
              <td style={{width: '50%'}}><a href="#"
                                            onClick={(e) => this.handleClientChange(e, x.clientId)}>{x.clientCompanyName}</a>
              </td>
              <td><i className={x.isTinLocation ? 'fa fa-check' : 'fa fa-times'}/></td>
            </tr>);
          })}
          </tbody>
        </table>
      </div>}
      <div className="row">&nbsp;</div>

      {!hasSelection && hasFullAccess && <div className="row">
        <table className="table table-responsive table-striped" style={{minWidth: '300px'}}>
          <thead>
          <tr>
            <th style={{width: '100%'}}>Client Name</th>
            <th>Locations</th>
            <th>Active</th>
          </tr>
          </thead>
          <tbody>
          {this.props.clients.items.length === 0 && !this.props.clients.loaded && <tr>
            <td>Searching...</td>
            <td>&nbsp;</td>
          </tr>}
          {this.props.clients.items.length === 0 && this.props.clients.loaded && <tr>
            <td>Please search for a client</td>
            <td>&nbsp;</td>
          </tr>}
          {this.props.clients.items.map(x => {
            return (<tr key={x.id}>
              <td style={{width: '100%'}}><a href="#"
                                             onClick={(e) => this.handleClientChange(e, x.id)}>{x.companyName}</a>
              </td>
              <td>{x.locationsCount}</td>
              <td><i className={x.isInactive ? 'fa fa-times text-danger' : 'fa fa-check text-success'}/></td>
            </tr>);
          })}
          </tbody>
        </table>
      </div>}

      <Outlet />

    </div>);
  }
}

LocationsPage.propTypes = {

};

function mapStateToProps(state, ownProps){
  let clientId = null;
  // Check routeParams first (from withRouter)
  if(ownProps.routeParams && ownProps.routeParams.id && ownProps.location.pathname.includes('clients')){
    clientId = ownProps.routeParams.id;
  } else if(ownProps.location)
  {
    let queryTags = querySearch(ownProps.location.search);
    if(queryTags && queryTags.clientId){
      clientId = queryTags.clientId;
    }
  }

  return {
    locations: state.locations,
    account: state.account,
    clients: state.clients,
    bdms: state.bdms,
    clientId,
    location: ownProps.location,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationsPage));
